'use strict';
var $defineProperty = require('es-define-property');
var hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    if (!$defineProperty) {
        return null;
    }
    try {
        return $defineProperty([], 'length', { value: 1 }).length !== 1;
    } catch (e) {
        return true;
    }
};
module.exports = hasPropertyDescriptors;